import { Tooltip } from "antd";
import React from "react";

/**
 * CardNumber component displays a card with a title, value, and optionally new users and a color.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.title - The title to be displayed on the card.
 * @param {number} props.value - The value to be displayed on the card.
 * @param {number} [props.newUsers] - The number of new users to be displayed (currently commented out).
 * @param {string} [props.color="#282828"] - The color of the value text.
 * @returns {JSX.Element} The rendered CardNumber component.
 */
export const CardNumber = ({ textBefore, anterior = 0, title, value, newUsers, color = "#282828" }) => {
    const isPositive = newUsers >= 0;
    return (
        <div className="w-[244px] min-w-[244px] h-[144px] bg-white rounded-2xl shadow-sm p-4">
            <div className="flex justify-between ">
                <p className="text-[#9A9A9A] text-[10px]">{textBefore}</p>
                <Tooltip placement="bottom" title={`Periodo anterior: ${anterior}`}>
                    <div className={`w-10 h-4 ${isPositive ? "bg-[#55ae7040]" : "bg-[#d9534f40] "}  rounded flex justify-between items-center px-1`}>
                    <svg className={`w-3 h-3 ${!isPositive && "rotate-180"}`} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path d="M7 6H1L3.82353 2L7 6Z" fill={`${isPositive ? "#55AE70" : "#D9534F"}`} />
                    </svg>
                    <p className={`text-[10px] text-[${isPositive ? "#55ae70" : "#D9534F"}] font-medium`}>{newUsers}</p>
                </div>
                </Tooltip>
            </div>
            <div className="pt-2 w-full text-center">
                <p className="text-sm text-black leading-5 font-bold">{title}</p>
                <p className={
                    `pt-2 leading-5 text-[32px] ${color} font-bold`
                }>{value?.toLocaleString()}</p>
            </div>
        </div>
    )
}

export default CardNumber;
